import { InjectionToken } from '@angular/core';

export const APP_NAME = new InjectionToken<string>('APP_NAME');
